import { GRID_SIZE, type ViewportTransform } from '../types';

/**
 * The dot grid behind the nodes: one dot per grid cell, painted on a layer that reaches a cell
 * past the canvas on every side. A pan only shifts that layer (by less than a cell: the pattern
 * repeats), so the dots follow the view without being painted again. Another zoom needs
 * another painting.
 */

// The line colour of the theme in force (index.css), so the dots turn with the dark theme
const DOT_COLOR = 'var(--line)';

/** How the layer is painted at a zoom. */
export const gridPaint = (scale: number) => {
    const cell = GRID_SIZE * scale;
    const dot = Math.max(0.5, scale);
    return {
        inset: `${-cell}px`,
        backgroundImage: `radial-gradient(circle, ${DOT_COLOR} ${dot}px, transparent ${dot}px)`,
        backgroundSize: `${cell}px ${cell}px`,
    };
};

/**
 * The shift that lines the painted dots up with the view, as a CSS transform. Each part is at
 * least 0 and under one cell, so the layer still covers the canvas, and lies on a whole screen
 * pixel, so the layer is not blurred by being drawn between two.
 */
export const gridShift = (t: ViewportTransform, devicePixelRatio = 1): string => {
    const cell = GRID_SIZE * t.scale;
    const within = (offset: number) => Math.floor((((offset % cell) + cell) % cell) * devicePixelRatio) / devicePixelRatio;
    return `translate3d(${within(t.x)}px, ${within(t.y)}px, 0)`;
};
